import { createFileRoute, Navigate, useNavigate } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { z } from 'zod'
import { Spinner } from '~/elements'
import { workspacesQueryOptions } from '~/queries'
import { useLocalStore } from '~/stores'

const checkoutSearchSchema = z.object({
  plan: z
    .enum(['plus', 'team'])
    .optional()
    .catch(() => undefined),
  cycle: z
    .enum(['monthly', 'annual'])
    .optional()
    .catch(() => undefined),
})

export const Route = createFileRoute('/checkout')({
  validateSearch: checkoutSearchSchema,
  component: CheckoutBridgeComponent,
})

function CheckoutBridgeComponent() {
  const { plan, cycle } = Route.useSearch()
  const { data: workspaces } = useSuspenseQuery(workspacesQueryOptions())
  const lastActiveWorkspaceId = useLocalStore((s) => s.lastActiveWorkspaceId)
  const navigate = useNavigate()

  // Validate lastActiveWorkspaceId against the fetched list to avoid stale references
  const workspaceId = workspaces.find((w) => w.id === lastActiveWorkspaceId)?.id ?? workspaces[0]?.id

  useEffect(() => {
    if (!workspaceId || !plan || !cycle) return

    void navigate({
      to: '/workspaces/$workspaceId/checkout-trigger',
      params: { workspaceId },
      search: { plan, cycle },
      replace: true,
    })
  }, [workspaceId, plan, cycle, navigate])

  if (!workspaceId || !plan || !cycle) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4">
      <Spinner size="4" />
      <p className="text-sm text-muted-foreground">Preparing your checkout...</p>
    </div>
  )
}
